import { rem } from "@certn/cascadia";
import {
  BasicButton,
  BrandAsset,
  Space,
  useMediaQuery,
} from "@certn/cascadia-react";
import { css } from "@emotion/css";
import { Trans } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";

import { SettingsDropdown } from "./SettingsDropdown";

interface Props {
  hideSettings?: boolean;
  showLoginButton?: boolean;
}

export function AppHeader({ showLoginButton, hideSettings }: Props) {
  const navigate = useNavigate();
  const handleLogin = () => navigate(`/auth?redirect=/`);
  const { mediaQuery } = useMediaQuery();

  return (
    <div
      className={css(
        styles.header,
        mediaQuery({
          paddingLeft: [rem("space-2"), rem("space-6")],
          paddingRight: [rem("space-2"), rem("space-6")],
        })
      )}
    >
      <Link to="/">
        <BrandAsset height="32" width="110" type="full" brand="certn" />
      </Link>
      <Space />

      {!hideSettings && <SettingsDropdown />}
      {showLoginButton && (
        <BasicButton onPress={handleLogin} size="medium">
          <Trans>Login</Trans>
        </BasicButton>
      )}
    </div>
  );
}

const styles = {
  header: css({
    display: "flex",
    alignItems: "center",
    minHeight: rem("space-16"),
    gap: rem("space-4"),
  }),
};
